/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsUpLeft = createReactComponent("arrows-up-left", "IconArrowsUpLeft", [
  ["path", { d: "M21 7l-4 -4l-4 4", key: "svg-0" }],
  ["path", { d: "M17 3v11a3 3 0 0 1 -3 3h-11", key: "svg-1" }],
  ["path", { d: "M7 13l-4 4l4 4", key: "svg-2" }]
]);

export { IconArrowsUpLeft as default };
//# sourceMappingURL=IconArrowsUpLeft.js.map
